import { SupportCaseStatus } from "../types";

export const SUPPORT_CASE_STATUS_LABELS: Record<SupportCaseStatus, string> = {
  [SupportCaseStatus.OPEN]: "Open",
  [SupportCaseStatus.ASSIGNED]: "Assigned",
  [SupportCaseStatus.IN_PROGRESS]: "In Progress",
  [SupportCaseStatus.AWAITING_RESPONSE]: "Awaiting Response",
  [SupportCaseStatus.RESOLVED]: "Resolved",
  [SupportCaseStatus.CLOSED]: "Closed",
};

export function supportCaseStatusColor(
  status: SupportCaseStatus,
): "default" | "success" | "warning" | "info" | "error" {
  switch (status) {
    case SupportCaseStatus.OPEN:
      return "info";
    case SupportCaseStatus.ASSIGNED:
      return "warning";
    case SupportCaseStatus.IN_PROGRESS:
      return "info";
    case SupportCaseStatus.AWAITING_RESPONSE:
      return "warning";
    case SupportCaseStatus.RESOLVED:
      return "success";
    case SupportCaseStatus.CLOSED:
      return "default";
    default:
      return "default";
  }
}
